import {
    GET_ALUMNO_LIST,
    GET_ALUMNO_DETAIL,
    PUT_ALUMNO_EDIT,
    POST_ALUMNO_CREATE,
    DELETE_ALUMNO,
    PUT_ALUMNO_COBRO,
    PUT_ALUMNO_COBRO_H,
    PUT_ALUMNO_COBRO_SERVICIO,
    GET_CORTE_CAJA,
    GET_CORTE_CAJA_PagoPorConceptoCobro,
    GET_CORTE_CAJA_PagoPoUsuarioAlta,
    GET_CORTE_CAJA_PagoPorTipoPago,

    GET_CORTE_CAJA_PagoPorConceptoCobroPorUsuario,
    GET_CORTE_CAJA_PagoPoUsuarioAltaPorUsuario,
    GET_CORTE_CAJA_PagoPorTipoPagoPorUsuario,
    GET_CORTE_CAJA_CobroPorUsuario,
    GET_CORTE_CAJA_ComisionUsuario,
    GET_CORTE_CAJA_ConsolidadoUsuario,

    PUT_ALUMNO_COBRO_EN_PAGOS,
    PUT_CERRAR_CORTE_CAJA
} from "./AlumnoAction";

let initialState = {
    getCorteCaja: false,
    errorCorteCaja: false,
    getPagoPorConceptoCobro: false,
    errorPagoPorConceptoCobro:false,

    getPagoPorUsuarioAlta: false,
    errorPagoPorUsuarioAlta: false,
    getPagoPorTipoPago: false,
    errorPagoPorTipoPago: false,

    getCobroPorUsuario: false,
    errorCobroPorUsuario: false,

    getComisionPorUsuario: false,
    errorComisionPorUsuario: false,

    getConsolidadoPorUsuario: false,
    errorConsolidadoPorUsuario: false,

    getAlumnoList:           false,
    errorAlumnoList:         false,
    getAlumnoDetail:         false,
    errorAlumnoDetail:       false,
    getResponDataAlumno:     false,
    errorResponDataAlumno:   false,
    getResponDataAlumnoC:    false,
    errorResponDataAlumnoC:  false,
    getAlumnoBorrar:         false,
    errorAlumnoBorrar:       false,
};

const AlumnoReducer = (state = initialState, action) => {
    //console.log(action.type);

    switch (action.type) {

        case GET_CORTE_CAJA:
        return {
            ...state,
            getCorteCaja: action.payload.data,
            errorCorteCaja: action.payload.errorMessage,
        };

        case GET_CORTE_CAJA_PagoPorConceptoCobro:
        return {
            ...state,
            getPagoPorConceptoCobro: action.payload.data,
            errorPagoPorConceptoCobro: action.payload.errorMessage,
        };


        case GET_CORTE_CAJA_PagoPoUsuarioAlta:
        return {
            ...state,
            getPagoPorUsuarioAlta: action.payload.data,
            errorPagoPorUsuarioAlta: action.payload.errorMessage,
        };

            
        case GET_CORTE_CAJA_PagoPorTipoPago:
            return {
                ...state,
                getPagoPorTipoPago: action.payload.data,
                errorPagoPorTipoPago: action.payload.errorMessage,
            };


        
        case GET_CORTE_CAJA_PagoPorConceptoCobroPorUsuario:
        return {
            ...state,
            getPagoPorConceptoCobro: action.payload.data,
            errorPagoPorConceptoCobro: action.payload.errorMessage,
        };
        
        case GET_CORTE_CAJA_PagoPoUsuarioAltaPorUsuario:
        return {
            ...state,
            getPagoPorUsuarioAlta: action.payload.data,
            errorPagoPorUsuarioAlta: action.payload.errorMessage,
        };
        
        case GET_CORTE_CAJA_PagoPorTipoPagoPorUsuario:
        return {
            ...state,
            getPagoPorTipoPago: action.payload.data,
            errorPagoPorTipoPago: action.payload.errorMessage,
        };

        case GET_CORTE_CAJA_CobroPorUsuario:
            return {
                ...state,
                getCobroPorUsuario: action.payload.data,
                errorCobroPorUsuario: action.payload.errorMessage,
            };

        case GET_CORTE_CAJA_ComisionUsuario:
            return {
                ...state,
                getComisionPorUsuario: action.payload.data,
                errorComisionPorUsuario: action.payload.errorMessage,
            };

        case GET_CORTE_CAJA_ConsolidadoUsuario:
            return {
                ...state,
                getConsolidadoPorUsuario: action.payload.data,
                errorConsolidadoPorUsuario: action.payload.errorMessage,
            };


        case GET_ALUMNO_LIST:
            return {
                ...state,
                getAlumnoList: action.payload.data,
                errorAlumnoList: action.payload.errorMessage,
            };

        case GET_ALUMNO_DETAIL:

            return {
                ...state,
                getAlumnoDetail: action.payload.data,
                errorAlumnoDetail: action.payload.errorMessage,
            };

        case PUT_ALUMNO_EDIT:
            return {
                ...state,
                getResponDataAlumno: action.payload.data,
                errorResponDataAlumno: action.payload.errorMessage,
            };

        case PUT_ALUMNO_COBRO:
            return {
                ...state,
                getResponDataAlumno: action.payload.data,
                errorResponDataAlumno: action.payload.errorMessage,
            };

        case PUT_CERRAR_CORTE_CAJA:
            //console.log("hola-3----" + action.payload.data);
            return {
                ...state,
                getResponDataAlumno: action.payload.data,
                errorResponDataAlumno: action.payload.errorMessage,
            };


        case PUT_ALUMNO_COBRO_EN_PAGOS:
            return {
                ...state,
                getResponDataAlumno: action.payload.data,
                errorResponDataAlumno: action.payload.errorMessage,
            };

        case PUT_ALUMNO_COBRO_H:
            return {
                ...state,
                getResponDataAlumno: action.payload.data,
                errorResponDataAlumno: action.payload.errorMessage,
            };

        case PUT_ALUMNO_COBRO_SERVICIO:
            return {
                ...state,
                getResponDataAlumno: action.payload.data,
                errorResponDataAlumno: action.payload.errorMessage,
            };

        case POST_ALUMNO_CREATE:
            return {
                ...state,
                getResponDataAlumnoC: action.payload.data,
                errorResponDataAlumnoC: action.payload.errorMessage,
            };

        case DELETE_ALUMNO:
            return {
                ...state,
                getAlumnoBorrar: action.payload.data,
                errorAlumnoBorrar: action.payload.errorMessage,
            };
            

        default:
            return state;


    }//END SWITCH

}//END FUNCTION

export default AlumnoReducer;